<template>
  <td v-if="type != null">
    <div>
      <component
        :is="renderComponent"
        class="mr-1"
        v-for="link in links"
        :key="link"
        :to="'/dialogkontrolle/' + link"
      >
        {{ link }}
      </component>
    </div>
    <span v-if="type == 2" class="badge badge-info">ASA</span>
    <span v-else-if="type <= 1" class="badge badge-success"> Nachricht</span>
    <span v-if="isNew" class="badge badge-danger"> Neu</span>
  </td>
  <td v-else v-html="nullHtml"></td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
  props: ['content', 'model', 'attribute'],
  computed: {
    renderComponent() {
      if (!this.$route) {
        return "span";
      } else {
        return "router-link";
      }
    },
    links() {
      if (Array.isArray(this.content)) {
        return this.content;
      } else {
        return [this.content];
      }
    },
    type() {
      return this.model !== null ? ( this.model.type ? this.model.type :
        this.model.dialogInModeration ? this.model.dialogInModeration.type : null ) : null;
    },
    isNew() {
      return this.model !== null ? ( this.model.is_new ? this.model.is_new :
        this.model.dialogInModeration ? this.model.dialogInModeration.is_new : false ) : false;
    },
    nullHtml() {
      return defaultNullHtml();
    },
  },
};
</script>
